import { render, staticRenderFns } from "./StagePayment.vue?vue&type=template&id=ca272fc8"
import script from "./StagePayment.vue?vue&type=script&lang=ts"
export * from "./StagePayment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports